const T = require("react").PropTypes;

const FileType = {
    Type: T.shape({
        PKID: T.number,
        ClassName: T.string,
        DisplayName: T.string,
        ColumnCount: T.number
    })
};

module.exports = FileType;


// WEBPACK FOOTER //
// ./src/types/FileType.js